export default __webpack_public_path__ + "static/media/slide2.c225c9cb.jpg";